import ErrorPage from './ErrorPage';
import NotFound from './NotFound';

export { ErrorPage, NotFound };
